import React from 'react';
import {View, StyleSheet, StyleProp, ViewStyle} from 'react-native';
import type {Route} from '@react-navigation/native';
import Badge from './Badge';

type Props = {
  route: Route<string>;
  horizontal: boolean;
  badge?: string | number;
  activeOpacity: number;
  inactiveOpacity: number;
  activeTintColor: string;
  inactiveTintColor: string;
  renderIcon: (props: {focused: boolean; color: string; size: number}) => React.ReactNode;
  style: StyleProp<ViewStyle>;
};

export default function TabBarIcon({
  horizontal,
  badge,
  activeOpacity,
  inactiveOpacity,
  activeTintColor,
  inactiveTintColor,
  renderIcon,
  style,
}: Props) {
  const size = 25;
  return (
    <View style={[styles.iconWrapper, style]}>
      <View style={[styles.icon, {opacity: activeOpacity}]}>
        {renderIcon({
          focused: true,
          size,
          color: activeTintColor,
        })}
      </View>
      <View style={[styles.icon, {opacity: inactiveOpacity}]}>
        {renderIcon({
          focused: false,
          size,
          color: inactiveTintColor,
        })}
      </View>
      <Badge
        visible={badge != null}
        style={[styles.badge, horizontal ? styles.badgeHorizontal : styles.badgeVertical]}
        size={(size * 3) / 4}>
        {badge}
      </Badge>
    </View>
  );
}

const styles = StyleSheet.create({
  icon: {
    position: 'absolute',
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'flex-end',
    height: '100%',
    width: '100%',
    minWidth: 25,
  },
  iconWrapper: {
    width: '100%',
    flex: 1,
  },
  badge: {
    position: 'absolute',
    left: 3,
  },
  badgeVertical: {
    top: 3,
  },
  badgeHorizontal: {
    top: 7,
  },
});
